var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle4, _circle5, _path19, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path20, _path21, _rect, _rect2, _rect3, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKnower = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 539,
  height: 524,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 281.5,
  cy: 257.5,
  r: 202.5,
  stroke: "#EFF3F9",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 281.5,
  cy: 257.5,
  r: 256.5,
  stroke: "#EFF3F9",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  r: 174.213,
  transform: "matrix(-1 0 0 1 279.948 254.521)",
  fill: "#EFF3F9"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M333.861 450.958c26.206-18.55 104.85-54.764 108.87-180.379-47.635 17.869-136.097 78.962-108.87 180.379Z",
  fill: "#83AB5B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M331.768 449.626c22.107 8.936 76.289 43.558 156.406-4.323-30.277-22.601-103.946-53.378-156.406 4.323ZM334.725 430.807c11.708-20.772 53.017-70.045 15.851-155.66-26.311 27.115-66.318 96.208-15.851 155.66Z",
  fill: "#83AB5B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m436.984 279.029-99.31 153.336M349.458 285.723l-21.613 114.359M482.288 444.535l-143.333 2.825M440.929 423.829l-17.817 22.311 17.328 18.137M394.421 421.868l-9.816 24.045 27.353 24.423M411.976 379.428l-43.259 5.72M378.709 310.731l5.672 48.522M435.91 321.376l-28.37 2.779-3.228-32.384M347.164 364.139l4.359 46.041M359.991 302.949l-16.867 20.134-15.454-14.921M338.678 348.835l-20.694-17.6",
  stroke: "#000",
  strokeWidth: 2.042
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m210.423 182.442 34.374-26.221-9.515-22.52c-6.113 6.776-19.643 21.534-24.859 26.358-6.52 6.029-20.633-10.08-27.75-16.15-7.118-6.069-11.606-17.341-15.527-26.105-1.632-1.632-4.179-2.285-1.306 8.161-2.503-5.332-7.051-12.927-5.223-.653-1.197-3.155-3.591-8.291-3.591-3.591.109 1.742.783 5.746 2.612 7.835 1.746 6.545 7.229 21.794 15.188 30.437 10.631 16.218 28.636 20.626 35.597 22.449Z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m274.55 100.815-9.141-32.645-20.893 7.835 5.876 30.36 24.158-5.55ZM332.659 438.058v-23.179l-21.22-2.611v25.79h21.22ZM287.935 424.02l-9.141-20.241-21.873 8.162 10.773 21.872 20.241-9.793Z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2.042
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M340.167 422.387c2.612-26.9-26.116-180.748-40.807-254.309l-60.72 3.918c-12.188 46.247-36.564 142.334-36.564 156.698 0 14.364 31.34 72.582 47.01 99.896l35.91-25.79c-12.187-24.049-36.432-73.387-35.91-78.35.522-4.962 9.141-81.069 13.385-118.503l30.687 216.44h47.009Z",
  fill: "#FFC327"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m349.961 150.449-35.91-29.381-20.24 13.712c7.834 4.679 24.941 15.082 30.686 19.26 7.182 5.224-5.876 22.199-10.446 30.361-4.571 8.161-14.038 1.632-21.873 7.182-2.503 1.306-6.855 3.917-4.244 3.917 2.612 0 6.529-1.523 8.162-2.285-2.83 1.415-8.292 4.375-7.509 4.897.98.653 5.224 0 8.488-.979 3.265-.98-6.529 3.917-4.897 4.57 1.633.653 5.55-1.959 8.815-1.959 3.264 0 5.549 1.306 7.508 1.306 1.959 0-7.508.653-6.203 1.959 1.306 1.306 3.918 1.958 9.794 0 4.701-1.567 14.984-10.194 19.538-14.312 13.623-13.544 17.899-31.114 18.331-38.248Z",
  fill: "#fff"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m349.961 150.449-35.91-29.381-20.24 13.712c7.834 4.679 24.941 15.082 30.686 19.26 7.182 5.224-5.876 22.199-10.446 30.361-4.571 8.161-14.038 1.632-21.873 7.182-2.503 1.306-6.855 3.917-4.244 3.917 2.612 0 6.529-1.523 8.162-2.285-2.83 1.415-8.292 4.375-7.509 4.897.98.653 5.224 0 8.488-.979 3.265-.98-6.529 3.917-4.897 4.57 1.633.653 5.55-1.959 8.815-1.959 3.264 0 5.549 1.306 7.508 1.306 1.959 0-7.508.653-6.203 1.959 1.306 1.306 3.918 1.958 9.794 0M174.826 159.993c10.631 16.218 28.636 20.626 35.597 22.449l34.374-26.221-9.515-22.52c-6.113 6.776-19.643 21.534-24.859 26.358-6.52 6.029-20.633-10.08-27.75-16.15-7.118-6.069-11.606-17.341-15.527-26.105-1.632-1.632-4.179-2.285-1.306 8.161-2.503-5.332-7.051-12.927-5.223-.653-1.197-3.155-3.591-8.291-3.591-3.591.109 1.742.783 5.746 2.612 7.835",
  stroke: "#000",
  strokeWidth: 2.042
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M234.722 80.577c-10.446-5.224-10.446-27.096-6.529-35.258.435-1.414 2.481-4.962 7.182-7.835 5.876-3.59 16.649-.326 24.158.653 6.007.784 6.855 12.514 6.529 18.282.217-.218 1.045-.914 2.612-1.959 6.202-3.917 14.69 3.918 10.12 12.405-3.657 6.79-10.447 3.7-13.385 1.306-5.876 15.344-20.24 17.629-30.687 12.406Z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2.042
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M234.722 80.577c-10.446-5.224-10.446-27.096-6.529-35.258.435-1.414 2.481-4.962 7.182-7.835 5.876-3.59 16.649-.326 24.158.653 6.007.784 6.855 12.514 6.529 18.282.217-.218 1.045-.914 2.612-1.959 6.202-3.917 14.69 3.918 10.12 12.405",
  stroke: "#000",
  strokeWidth: 2.042
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M255.615 49.89c-.261 7.312 6.856 7.617 10.447 6.855.109-.327.914-1.306 3.264-2.612 2.351-1.306 4.68-.98 5.55-.653 1.197-3.264 3.46-12.079 2.938-21.22-.522-9.14-8.923-9.249-13.058-8.16-.544-.762-2.546-2.547-6.203-3.592-16.323-3.917-24.157 5.224-27.422 6.856-3.265 1.632-8.161-.653-8.161 0 .522 1.306 3.264 2.067 4.57 2.285-2.612 1.045-5.876.435-7.182 0-.544.653.131 3.722 7.182 10.773 7.051 7.052 22.525 2.285 29.381-.98-.326.436-1.045 3.135-1.306 10.447Z",
  fill: "#FF9078"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M268.348 95.267c7.312-13.058 32.21 8.488 43.745 20.893l5.223 5.223c-5.223.523-14.146 14.364-17.955 21.22-13.385-10.338-38.326-34.278-31.013-47.336Z",
  fill: "#65A0F1"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M235.049 115.834c4.962-14.103 24.049-17.846 32.972-17.955 4.135 1.959 13.515 6.464 17.955 8.814 17.237 26.9 21.111 56.912 20.893 68.556-17.498 12.536-57.13 10.664-74.758 8.161-1.089-16.649-2.024-53.473 2.938-67.576Z",
  fill: "#65A0F1"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M247.301 98.372c14.965.2 7.902 32.359 2.499 48.414l-2.1 7.082c-2.95-4.341-19.372-5.583-27.214-5.661 2.703-16.695 11.85-50.034 26.815-49.835Z",
  fill: "#65A0F1"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M308.175 435.445h26.769l1.633 31.667c-22.743 2.176-68.425 4.635-69.209-2.939-.783-7.573 26.878-17.084 40.807-20.893v-7.835Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.724
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "m287.935 417.816 5.55 10.773 18.934 13.059-12.079 24.157c-14.473 2.286-45.965 5.485-56.15 0-10.186-5.484 11.426-11.861 23.505-14.364l1.632-9.793-6.529-8.162 25.137-15.67Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.724
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M269.327 59.696c2.067-1.306 6.137-2.873 5.876 1.306-.327 5.223-2.612 4.897-5.876 4.57M236.028 53.818c0 3.047-.391 9.402-1.958 10.447s.652 2.394 1.958 2.938",
  stroke: "#000",
  strokeWidth: 2.042
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M234.517 73.026c2.049 2.028 6.604 1.11 8.626.396-.12.593-1.009 1.95-3.605 2.636-3.246.859-5.545-2.97-5.021-3.032Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 2.042
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  r: 1.306,
  transform: "matrix(-1 0 0 1 246.801 58.716)",
  fill: "#000"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  r: 1.306,
  transform: "matrix(-1 0 0 1 229.826 58.064)",
  fill: "#000"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "m262.145 205.947 30.36 215.461M288.261 200.07l35.91 219.705M246.801 203.336l-22.525 121.441 45.703 87.164",
  stroke: "#000",
  strokeWidth: 2.042
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 289.567 159.591)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 269.979 138.044)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 262.145 161.548)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 245.169 140.003)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 292.832 140.003)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 260.839 115.845)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 298.055 114.541)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 280.426 101.482)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 238.64 164.162)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  r: 4.754,
  transform: "matrix(-1 0 0 1 234.069 121.722)",
  stroke: "#fff",
  strokeWidth: 2.897
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M268.347 98.543c3.591 10.447 14.103 33.364 27.423 41.46M250.719 102.461c-5.115 7.835-15.866 27.161-17.955 41.786",
  stroke: "#000",
  strokeWidth: 2.042
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M307.981 434.869v7.835c-13.928 3.809-41.59 13.319-40.807 20.893",
  stroke: "#fff",
  strokeWidth: 2.042
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24.926,
  height: 24.926,
  rx: 3,
  transform: "scale(-1 1) rotate(-42.007 14.726 703.787)",
  fill: "#A7C6EF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  width: 14.5,
  height: 14.5,
  rx: 3,
  transform: "scale(-1 1) rotate(-42.007 -164.777 490.303)",
  fill: "#A7C6EF"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  width: 14.5,
  height: 14.5,
  rx: 3,
  transform: "scale(1 -1) rotate(61.795 371.924 -49.859)",
  fill: "#A7C6EF"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "m123.411 97.695-3.683 8.366 54.519 26.861 5.525-12.549-56.361-22.678ZM186.536 131.45c-1.526 3.465-5.705 4.978-9.336 3.38l5.526-12.549c3.63 1.599 5.336 5.704 3.81 9.169ZM114.645 97.655a1.449 1.449 0 0 0-.975 2.213l3.261 5.057 3.646-8.28-5.932 1.01Z",
  fill: "#FF9078"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M13.261 50.822s-1.636-1.218-2.82-1.137c-1.677.115-2.727.749-3.09 2.389-.756 3.417 6.335 4.59 4.942 7.751-1.516 3.438-5.711 1.432-7.539-.644M20.216 47.165l-.597.38M18.145 51.902s-1.57 4.773-1.836 8.299c-.076.997 1.14 1.789 1.14 1.789M24.001 53.198s.38.598-1.08 4.882c-1.46 4.285-1.08 4.882-1.08 4.882.272 1.084 4.601-9.224 7.042-8.683 2.543.564-.428 6.561-.208 10.196.09 1.496 1.248 1.3 1.248 1.3M49.386 58.815s-5.14 11.664-10.512 10.475c-2.593-.573-3.081-3.61-2.227-6.126.845-2.487 2.8-3.989 5.364-3.421 6.28 1.39 1.258 10.52 4.675 11.276 1.465.325 1.681-.652 1.681-.652M57.042 68.191l4.774 1.569M93.66 80.904l3.798 1.353M57.798 64.773l.15.003c1.584.033 3.146.378 4.595 1.017l.137.06M94.416 77.486l1.361.028c.79.016 1.577.11 2.349.281l.304.067",
  stroke: "#FF9078",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M78.186 60.582c.44-1.987-3.267-2.9-5.024-3.219a.945.945 0 0 0-1.086.744l-2.298 10.384a.946.946 0 0 0 .729 1.147c2.005.397 6.61 1.018 7.523-1.41 1.244-3.309-6.079-4.93-6.079-4.93s5.695-.276 6.235-2.716ZM84.12 86.986c.544-2.456-3.392-3.758-5.25-4.231-.521-.132-1.027.204-1.143.728L75.125 95.24a.95.95 0 0 0 .765 1.156c2.161.35 7.212.864 8.075-1.763 1.568-4.773-7.055-5.146-7.055-5.146s6.67-.06 7.21-2.5Z",
  stroke: "#FF9078",
  strokeWidth: 2
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M92.451 63.226s-.65-1.68-2.604-2.113c-2.013-.445-6.615 2.12-7.371 5.538-.54 2.441-.142 5.198 2.228 6.126 1.886.739 4.23-.6 4.23-.6M67.406 74.582l10.252 2.269 11.933 1.616M61.024 94.166 63.08 89.5m6.73 6.611.104-5.099m-6.834-1.513s4.493-8.735 5.958-8.41c1.953.431.876 9.923.876 9.923m-6.834-1.513 6.834 1.513M107.443 88.052s-4.992-.592-6.236 2.717c-.352.936-.16 3.037 1.687 3.958 1.642.819 4.119-.112 4.119-.112M103.096 79.92l.111.006c1.942.102 3.862.462 5.71 1.069l1.99.653M112.415 70.205s-1.634-1.103-2.821-1.137c-2.382-.067-4.71 1.752-4.498 4.126.124 1.375.685 2.327 1.901 2.98 2.339 1.26 5.606-6.44 6.014-6.35.409.09-1.512 6.835-1.512 6.835",
  stroke: "#FF9078",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgKnower;